import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from "../actions/actions";
import { withRouter } from "react-router";
import './Overview.css';
import ItemList from "./ItemList";
import Content from "./Content";
import {MODEL_INFO, MODEL_PAGES} from "../reducers/drfConnector";

class Overview extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount(){
    if(this.props.tile && !this.props.error){
      this.updateContent(this.props);
    }
  }

  componentDidUpdate(prevProps){
    if(!this.props.tile
      || (this.props.tile === prevProps.tile && !prevProps.error)
      || this.props.isFetchingList
      || this.props.error){
      return;
    }
    console.log("update to " + this.props.tile);
    this.updateContent(this.props);
  }

  updateContent(props){
    if(!Object.keys(this.props.models[MODEL_INFO]).length > 0){
      this.props.fetchList(MODEL_INFO)
    }
    if(!this.props.models[Overview.getModel(props)][props.tile]){
      this.props.fetchList(Overview.getModel(props))
    }
  }

  static getModel(props){
    if(props.tile === 'contact'){
      return MODEL_PAGES;
    }
    return props.tile
  }

  getContent(){
    let content;
    if(!this.props.tile){
      return {};
    }
    else if(this.props.tile === 'contact'){
      content = this.props.models[MODEL_PAGES]['/contact/'];
      if(!content){
        return {};
      }
      content.description = content.content;
      content.itemList = [];
    }
    else {
      content = this.props.models[MODEL_INFO][this.props.tile.replace(/s$/, '_index')];
      if(!content){
        return {};
      }
      content.itemList = this.props.models[this.props.tile];
    }

    return content
  }

  render(){
    if(this.props.error){
      return Content.renderError(this.props.error);
    }
    const content = this.getContent();
    const txt = {__html:content.description};
    const full_content = () => {
      return <div>
      <h1 key="headline">{content.title}</h1>
      <div dangerouslySetInnerHTML={txt}/>
      <ItemList itemList={content.itemList} view={this.props.tile}/>
    </div>};
    return <div id="content">
      {Content.renderContentTransition(this.props.tile, full_content())}
      {Content.renderFooter()}
      {Content.renderLoading(this.props.isFetchingList)}
    </div>
  }
}


const mapStateToProps = (state, props) => {
  return {
    ...props,
    tile: state.selection.tile,
    isHydrated: state.selection.isHydrated,
    error: state.drf.error,
    models: state.drf.models,
    isFetchingList: state.drf.isFetchingList,
  }
};

const OverviewWithRouter = withRouter(connect(
  mapStateToProps,
  actions
)(Overview));

export default OverviewWithRouter;



// WEBPACK FOOTER //
// ./src/components/Overview.js